/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ExportHistoryItemSchemaFormat } from './exportHistoryItemSchemaFormat';
import type { ExportHistoryItemSchemaStatus } from './exportHistoryItemSchemaStatus';

export interface ExportHistoryItemSchema {
  id: string;
  exported_by_id?: string | null;
  exported_by_name?: string | null;
  exported_by_avatar_url?: string | null;
  project_name?: string | null;
  source_type?: string | null;
  format: ExportHistoryItemSchemaFormat;
  profile_count: number;
  include_contacts: boolean;
  status: ExportHistoryItemSchemaStatus;
  download_url?: string | null;
  error?: string | null;
  can_retry?: boolean;
  created_at: string;
  credit_cost?: number | null;
}
